import serverInterface from 'server-interface';

class StaticData {

  constructor() {

    this.countries = null;
    this.continents = null;
    this.currencies = null;
    this.taxCodes = null;

  }

  async loadCountries() {

    if (this.countries !== null) {
      return this.countries;
    }

    this.countries = await import( /* @vite-ignore */ `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/data/countries.js`);

    return this.countries;

  }

  async loadContinents() {

    if (this.continents !== null) {
      return this.continents;
    }

    this.continents = await import( /* @vite-ignore */ `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/data/continents.js`);

    return this.continents;

  }

  async loadCurrencies() {

    if (this.currencies !== null) {
      return this.currencies;
    }

    this.currencies = await import( /* @vite-ignore */ `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/data/currencies.js`);

    return this.currencies;

  }

  async loadTaxCodes() {

    if (this.taxCodes !== null) {
      return [...this.taxCodes];
    }

    const taxCodes = await serverInterface.system.getTaxCodes();

    this.taxCodes = taxCodes.map(code => ({ label: code.name, value: code.id, key: code.id }));

    return [...this.taxCodes];

  }

  getTaxCodes() {

    return [...this.taxCodes];

  }

  filterTaxCodes(searchTerm) {

    if (searchTerm.trim() === '') {
      return [...this.taxCodes];
    }

    const filteredTaxCodes = [...this.taxCodes].filter(taxCode => taxCode.label.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b) => a.label.localeCompare(b.label));

    return filteredTaxCodes.slice(0, 10);

  }

  getTaxCodeById(id) {

    const code = this.taxCodes.find(taxCode => taxCode.value === id);

    if (code === void 0) {
      return null;
    }

    return structuredClone(code);

  }

}

export default StaticData;